'use client'

import { InfluencerDisclaimerModel } from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'

type Props = { data: InfluencerDisclaimerModel }

export const DisclaimerSection = ({ data: { text } }: Props) => {
  if (!text) return null

  return (
    <section data-testid="disclaimer-section" className="influencer-v2__disclaimer-section">
      <p className="influencer-v2__disclaimer-text">{text}</p>
    </section>
  )
}
